import { memo } from 'react'
import { Pressable } from 'react-native'
import styled from 'styled-components'
import { ChannelPromoPanel } from '../../content/ChannelPromoPanel/ChannelPromoPanel'

const calcHeight = (width, theme, sm) => {
  const gutter = theme.spacing.sm
  return ChannelPromoPanel.calcHeight(width - gutter, sm) + gutter
}

const Touchable = styled(Pressable)`
  padding-left: ${(props) => props.theme.spacing.sm / 2}px;
  padding-right: ${(props) => props.theme.spacing.sm / 2}px;
  padding-bottom: ${(props) => props.theme.spacing.medium}px;
`

const PremiereFeaturedContent = ({ channel, theme, width, onChosen }) => {
  return (
    <Touchable onPress={() => onChosen(channel)}>
      <ChannelPromoPanel channel={channel} width={width - theme.spacing.sm} />
    </Touchable>
  )
}

export const PremieresContent = memo(PremiereFeaturedContent)

PremieresContent.calcHeight = calcHeight
